export default __webpack_public_path__ + "static/drawer.dark-e4e7e3e798650998bc366285fad1b4598cb986e79ebb5c8671063b450eef3196.png";